const projects = [
  {
    image: "https://i.ibb.co/6FHfLrx/freshorganicfood.png",
    name: "FreshOrganicFood",
    technologies:
      "React.js, Tailwind CSS, React Hook Form,Context API,aos animation",
    liveLink: "https://freshorganicfood.netlify.app/",
    clientLink: "https://github.com/nasim0994/JBOrganicFood",
    serverLink: "",
  },
  {
    image: "https://i.ibb.co/MMWv1H4/maxui.png",
    name: "maxUi",
    technologies:
      "React.js, Express.js, MongoDB, Tailwind CSS, React Query, React Hook Form.",
    liveLink: "https://tailwindmaxui.netlify.app/",
    clientLink: "https://github.com/nasim0994/max_ui",
    serverLink: "https://github.com/nasim0994/maxUi-server",
  },
  {
    image: "https://i.ibb.co/Yc4FjZV/bikroy.png",
    name: "BikroyStore",
    technologies:
      "React.js, Express.js, MongoDB, Firebase, JWT, Tailwind CSS, React Query, Stripe, React Hook Form.",
    liveLink: "https://bikroystore-f0230.firebaseapp.com/",
    clientLink: "https://github.com/nasim0994/bikroyStory-client",
    serverLink: "https://github.com/nasim0994/bikroyStory-server",
  },
  {
    image: "https://i.ibb.co/5k3PfMh/Screenshot-1.png",
    name: "RainbowPhotography",
    technologies:
      "React.js, Express.js, MongoDB, Firebase, JWT, Context API, Tailwind CSS.",
    liveLink: "https://rainbow-photography.web.app/",
    clientLink: "https://github.com/nasim0994/rainbow-photography-client",
    serverLink: "https://github.com/nasim0994/rainbowPhotography-server",
  },
];

export default projects;
